import { useState, useContext, useEffect } from "react";
import { Row, Nav, Col, Button, Form, Alert, Card, Table, ButtonGroup, Modal, ProgressBar, Badge, Dropdown } from "react-bootstrap";

import Userprofile from "./Userprofile";

import axios from "axios";
import _ from "lodash";
import Utils from "../../common/Utils";
// import moment from "moment";
// import { useParams } from "react-router-dom";
import { UserContext } from "../../common";

// import MessageModal from "../../components/MessageModal";

const UserDocuments = (props) => {
  const { userData } = useContext(UserContext);
  // console.log(userData);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [nacounts,setNacounts] = useState([]);
  const [mode, setMode] = useState(0);
  const [selectedUser, setSelectedUser] = useState(0);
  const [filter, setFilter] = useState({ start: 0, limit: 10 });
  // const [message, setMessage] = useState(false);
  const [resources, setResources] = useState(false);
  const [status, setStatus] = useState(0);
  const [gapStatus, setGapStatus] = useState(0);
  const [total, setTotal] = useState(0);
  const [dtype, setDType] = useState(0);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");

  const fetchUsers = (showLoading = true) => {
    if (showLoading) setLoading(true);
    axios
      .get(Utils.apiUrl("users/fetchuserdocs/" + dtype), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setUsers(_.get(res, "data.users", []));
          setAllUsers(_.get(res, "data.all_users", []));
          setCategories(_.get(res, "data.categories", []));
          setTotal(_.get(res, "data.total"));
          setNacounts(_.get(res, "data.nacounts", []));
        }
        if (showLoading) setLoading(false);
      })
      .catch((err) => {
        if (showLoading) setLoading(false);
        console.log(err);
      });
  };

  const getStat = (status) => {
    if (status == 1) {
      return "Approved Documents";
    } else if (status == 2) {
      return "Pending Documents";
    } else if (status == 3) {
      return "Disapproved Documents";
    }
  };

  const fetchUserDocByID = (id = null, status = null) => {
    // setLoading(true);
    axios
      .get(Utils.apiUrl("users/fetchuserdocbyid/") + id + "/" + status, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setResources(_.get(res, "data.users", []));
        }
        // setLoading(false);
      })
      .catch((err) => {
        // setLoading(true);
        console.log(err);
      });
  };

  useEffect(fetchUsers, [dtype]);

  const openUserProfile = (user, { status = 0, gapStatus: gap = 0 } = {}) => {
    setSelectedUser(user);
    setStatus(status);
    setGapStatus(gap);
    setMode(3);
  };

  const showResources = () => {
    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setResources(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{getStat(resources[0].doc_status)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Documents</h3>
          <ol>
            {_.map(resources, (r) => (
              <li key={r.id} className="py-1">
                <a href={Utils.apiUrl("users/downloadudf") + "/" + r.file}>{r.udoc}</a>
              </li>
            ))}
          </ol>
        </Modal.Body>
      </Modal>
    );
  };

  if (!_.get(userData, "is_super_user", false)) {
    return (
      <div className="dt-canvas">
        <h1 className="alert alert-danger p-5 mt-5">No access!</h1>
      </div>
    );
  }

  const mergedList = _.concat(
    users,
    allUsers.filter((item) => !users.map((u) => u.id).includes(item.id))
  ).map(u => {
    const allUserMatch = allUsers.find(au => parseInt(au.id) === parseInt(u.id));
    const rawActive = u.is_active !== undefined ? u.is_active : allUserMatch?.is_active;
    const activeBool = rawActive === 1 || rawActive === "1" || rawActive === true;
    return {
      ...u,
      is_active: activeBool ? 1 : 0
    };
  });

  const filteredList = mergedList.filter(
    u => !search || (u.name && u.name.toLowerCase().includes(search.toLowerCase()))
  );

  const activeUsers = _.sortBy(
    filteredList.filter(u => u.is_active === 1),
    [u => (u.name || "").trim().toLowerCase()]
  );

  const inactiveUsers = _.sortBy(
    filteredList.filter(u => u.is_active !== 1),
    [u => (u.name || "").trim().toLowerCase()]
  );

  const combinedUsers = _.concat(activeUsers, inactiveUsers);

  return (
    <div className="dt-canvas" style={{ padding: "0 0 40px 0" }}>
      {/* Top Quick Actions (Unified Users Module Tabs) */}
      <Row className="px-2 mt-2 mb-3">
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/users`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Manage Users
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/roles`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Manage Roles
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/helpmat`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Manage Help Materials
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/userDocument`} className="w-100 btn btn-primary py-2 fw-bold">
            Staff Documents
          </a>
        </Col>
      </Row>

      <div className="dt-card">
        {loading && (
          <div className="text-center py-5">
            <div className="spinner-border text-primary mb-2" role="status"></div>
            <p className="text-muted fw-bold mb-0">Loading staff document records...</p>
          </div>
        )}

        {!loading && (
          <>
            {mode === 3 && (
              <>
                <div className="dt-card__head pb-3 mb-3 border-bottom">
                  <div>
                    <h2 className="dt-card__title">
                      User Document Profile: {selectedUser?.name}
                      {selectedUser?.is_active === 0 && (
                        <span 
                          className="badge ms-2" 
                          style={{ 
                            backgroundColor: "rgba(220, 38, 38, 0.12)", 
                            color: "#DC2626", 
                            border: "1px solid rgba(220, 38, 38, 0.25)", 
                            fontSize: "11px", 
                            fontWeight: 700, 
                            padding: "3px 8px", 
                            borderRadius: "4px" 
                          }}
                        >
                          Inactive Staff
                        </span>
                      )}
                    </h2>
                    <p className="text-muted small m-0">Detailed compliance portfolio and uploaded verification files</p>
                  </div>
                  <Button 
                    variant="outline-secondary" 
                    size="sm" 
                    onClick={() => {
                      setMode(0);
                      fetchUsers();
                    }} 
                    style={{ borderRadius: "8px", fontWeight: 600 }}
                  >
                    ← Back to Directory
                  </Button>
                </div>
                <Userprofile
                  key={`${selectedUser?.id || 0}-${status}-${gapStatus}-${dtype}`}
                  data={selectedUser}
                  status={status}
                  gapStatus={gapStatus}
                  cat={dtype}
                  onUpdate={() => fetchUsers(false)}
                />
              </>
            )}

            {mode === 0 && (
              <>
                {/* Title & Subtitle Row */}
                <div className="pb-3 mb-3 border-bottom">
                  <div className="mb-2">
                    <h2 className="dt-card__title" style={{ fontSize: "18px", fontWeight: 700, color: "var(--dt-navy)", margin: 0 }}>
                      Staff Compliance &amp; Document Tracker
                    </h2>
                    <p className="text-muted small m-0 mt-1">
                      Live document verification status and audit readiness per team member
                    </p>
                  </div>
                  {/* Search Bar Row */}
                  <div className="pt-2 d-flex flex-wrap align-items-center justify-content-between gap-2">
                    <div className="input-group" style={{ maxWidth: "360px" }}>
                      <span className="input-group-text bg-light border-end-0" style={{ borderColor: "#CBD5E1" }}>
                        <i className="bi bi-search text-muted"></i>
                      </span>
                      <input 
                        type="text" 
                        className="form-control border-start-0" 
                        placeholder="Search staff member..." 
                        value={search} 
                        onChange={e => setSearch(e.target.value)}
                        style={{ fontSize: "13px" }}
                      />
                      {search && (
                        <button 
                          className="btn btn-outline-secondary border-start-0 border" 
                          type="button" 
                          onClick={() => setSearch("")}
                          style={{ borderColor: "#CBD5E1" }}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Category Pill Tabs & Category Export */}
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3 pb-2 border-bottom">
                  <div className="d-flex flex-wrap gap-1.5 align-items-center" style={{ overflowX: "auto", maxWidth: "100%" }}>
                    <span className="fw-bold text-muted small text-uppercase me-2" style={{ letterSpacing: '0.5px', fontSize: '11px' }}>
                      <i className="bi bi-folder2-open me-1"></i> Categories:
                    </span>
                    <button
                      type="button"
                      className={`btn btn-sm py-1.5 px-3 fw-bold ${parseInt(dtype) === 0 ? "btn-primary shadow-sm" : "btn-light border"}`}
                      style={{ borderRadius: "8px", fontSize: "12px" }}
                      onClick={() => setDType(0)}
                    >
                      All ({total})
                    </button>
                    {_.map(categories, (cat, catidx) => {
                      const isActive = parseInt(dtype) === parseInt(catidx);
                      return (
                        <button
                          key={catidx}
                          type="button"
                          className={`btn btn-sm py-1.5 px-3 fw-bold ${isActive ? "btn-primary shadow-sm" : "btn-light border"}`}
                          style={{ borderRadius: "8px", fontSize: "12px" }}
                          onClick={() => setDType(catidx)}
                        >
                          {cat}
                        </button>
                      );
                    })}
                  </div>
                  {parseInt(dtype) > 0 && (
                    <div className="ms-auto">
                      <a 
                        href={Utils.apiUrl(`users/exportdata/0?cat=${dtype}&token=${Utils.getToken() || ""}`)} 
                        className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1 fw-bold"
                        style={{ borderRadius: "8px", padding: "6px 13px", fontSize: "12px" }}
                        title={`Download compliance spreadsheet for ${categories[dtype] || "selected category"}`}
                      >
                        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                        Export {categories[dtype] || "Category"} (.xlsx)
                      </a>
                    </div>
                  )}
                </div>

                <div className="table-responsive" style={{ border: "1.5px solid #E2E8F0", borderRadius: "10px", overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
                  <Table className="dt-table table-hover mb-0 text-nowrap" style={{ verticalAlign: "middle", minWidth: "720px" }}>
                    <thead>
                      <tr style={{ background: "#F8FAFC", borderBottom: "1.5px solid #E2E8F0" }}>
                        <th style={{ width: "45px", padding: "12px 14px", fontWeight: 700, color: "#475569" }}>#</th>
                        <th style={{ padding: "12px 14px", fontWeight: 700, color: "#475569" }}>Staff Member</th>
                        <th className="text-center" style={{ fontWeight: 700, color: "#475569" }}>Total</th>
                        <th className="text-center" style={{ fontWeight: 700, color: "#10B981" }}>Approved</th>
                        <th className="text-center" style={{ fontWeight: 700, color: "#F59E0B" }}>Pending</th>
                        <th className="text-center" style={{ fontWeight: 700, color: "#EF4444" }}>Disapproved</th>
                        <th className="text-center" style={{ fontWeight: 700, color: "#DC2626" }}>Expired</th>
                        <th className="text-center" style={{ fontWeight: 700, color: "#64748B" }}>N/A</th>
                      </tr>
                    </thead>
                    <tbody>
                      {combinedUsers.map((u, idx) => {
                        const isInactive = u.is_active === 0;
                        return (
                          <tr 
                            key={u.id || idx}
                            style={isInactive ? { backgroundColor: "#F8FAFC", opacity: 0.85 } : {}}
                          >
                            <td style={{ padding: "12px 14px", color: "#94A3B8", fontWeight: 600 }}>{idx + 1}</td>
                            <td style={{ padding: "12px 14px" }}>
                              <div 
                                className="d-flex align-items-center gap-2 clickable" 
                                onClick={() => openUserProfile(u)}
                                style={{ cursor: "pointer" }}
                              >
                                <div 
                                  className="who__face" 
                                  style={{ 
                                    width: 32, 
                                    height: 32, 
                                    fontSize: 13, 
                                    background: isInactive ? "rgba(100, 116, 139, 0.15)" : "rgba(0, 122, 255, 0.12)", 
                                    color: isInactive ? "#64748B" : "#007AFF", 
                                    fontWeight: 700 
                                  }}
                                >
                                  {(u.name || "U").charAt(0).toUpperCase()}
                                </div>
                                <div>
                                  <div className="d-flex align-items-center gap-2 flex-wrap">
                                    <span 
                                      className="fw-bold" 
                                      style={{ color: isInactive ? "#64748B" : "var(--dt-navy)", fontSize: "13.5px" }}
                                    >
                                      {u.name}
                                    </span>
                                    {isInactive && (
                                      <span 
                                        className="badge" 
                                        style={{ 
                                          backgroundColor: "rgba(220, 38, 38, 0.12)", 
                                          color: "#DC2626", 
                                          border: "1px solid rgba(220, 38, 38, 0.25)", 
                                          fontSize: "10px", 
                                          fontWeight: 700, 
                                          padding: "2px 6px", 
                                          borderRadius: "4px" 
                                        }}
                                        title="Inactive Team Member"
                                      >
                                        Inactive
                                      </span>
                                    )}
                                  </div>
                                  <div className="text-muted" style={{ fontSize: "11px" }}>{u.email || u.designation || "Staff"}</div>
                                </div>
                              </div>
                            </td>
                          <td className="text-center">
                            <span 
                              className="badge bg-primary px-2 py-1 clickable" 
                              style={{ cursor: "pointer", fontSize: "11.5px" }}
                              onClick={() => openUserProfile(u)}
                            >
                              {total}
                            </span>
                          </td>
                          <td className="text-center">
                            <span 
                              className="badge bg-success px-2 py-1 clickable" 
                              style={{ cursor: "pointer", fontSize: "11.5px" }}
                              onClick={() => openUserProfile(u, { status: 1 })}
                            >
                              {_.get(u, "app_count", 0)}
                            </span>
                          </td>
                          <td className="text-center">
                            <span 
                              className="badge bg-warning text-dark px-2 py-1 clickable" 
                              style={{ cursor: "pointer", fontSize: "11.5px" }}
                              onClick={() => openUserProfile(u, { status: 2 })}
                            >
                              {_.get(u, "pend_count", 0)}
                            </span>
                          </td>
                          <td className="text-center">
                            <span 
                              className="badge bg-danger px-2 py-1 clickable" 
                              style={{ cursor: "pointer", fontSize: "11.5px" }}
                              onClick={() => openUserProfile(u, { status: 3 })}
                            >
                              {_.get(u, "disapp_count", 0)}
                            </span>
                          </td>
                          <td className="text-center">
                            <span 
                              className="badge px-2 py-1 clickable" 
                              style={{ cursor: "pointer", fontSize: "11.5px", background: "#DC2626", color: "#fff" }}
                              onClick={() => openUserProfile(u, { status: 4 })}
                            >
                              {_.get(u, "expire_count", 0)}
                            </span>
                          </td>
                          <td className="text-center">
                            <span 
                              className="badge bg-secondary px-2 py-1 clickable" 
                              style={{ cursor: "pointer", fontSize: "11.5px" }}
                              onClick={() => openUserProfile(u, { gapStatus: 4 })}
                            >
                              {_.get(_.find(nacounts, n => n.user_id == u.id), "na_count", 0)}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                      {combinedUsers.length === 0 && (
                        <tr>
                          <td colSpan={8} className="text-center py-4 text-muted">
                            No team members found matching your search.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
                {_.get(resources, "length", 0) > 0 && showResources()}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default UserDocuments;
